import React, { useState } from "react";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

import InquiryFormModal from "../common_components/InquiryFormModal/InquiryFormModal";
import "./Footer.css";

const Footer = () => {
  const [modalshow, setmodalshow] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const pathname = location.pathname;

  const handleHomeClick = () => {
    if (pathname === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      navigate("/");
    }
  };

  const programs = [
    "MBA",
    "MBA(VX)",
    "MCA",
    "BBA",
    "BCA",
    "B.Com",
    "B.A",
    "CPDM",
    "CPHAHM",
  ];

  return (
    <section className="footer-section">
      <Container>
        <p className="footer_desc_text_holder">
          <b>Disclaimer:</b> As an Affiliate Enquiry Partner (AEP) of
          Universities, we display and showcase program information of
          Universities. Counseling, Admission, Program delivery, and examination
          are solely managed by Universities, and as an AEP, we have no role to
          play in it.
        </p>

        <div className="row justify-content-center">
          <div className="col-md-12 col-12">
            <div className="row">
              {/* Logo + Address */}
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mb-4">
                <div className="logo-content">
                  <div onClick={handleHomeClick} style={{ cursor: "pointer" }}>
                    <img
                      className="footerlogo"
                      src="/assets/images/header/logo.png"
                      alt="Logo"
                      width="180"
                      height="70"
                    />
                  </div>

                  <h3 className="title m-0">Address :</h3>

                  <p className="descript title">
                    2nd Floor, Office No. 3, M No. 734, Opp High Class Society,
                    Pashan Rd, near Suryadutta College, Patil Nagar, Bavdhan,
                    Pune, Maharashtra 411021
                  </p>
                </div>
              </div>

              {/* Programs */}
              <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12 mt-3 mb-4">
                <div className="links-sec">
                  <h3 className="title">Our Programs</h3>

                  <div className="row">
                    <div className="col-12">
                      {programs.map((program) => (
                        <div className="foot-menu title" key={program}>
                          <span>
                            <FontAwesomeIcon
                              icon={faAngleRight}
                              style={{ color: "#fff" }}
                            />
                          </span>

                          <p
                            style={{ cursor: "pointer" }}
                            onClick={() => setmodalshow(true)}
                          >
                            {program}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border"></div>

        {/* Bottom Section */}
        <div className="copyrights-div text-center">
          <p className="title">
            Our DPU Online MBA Course from Your City Location:
          </p>

          <p className="cities">
            Delhi | Hyderabad | Ahmedabad | Bengaluru | Mumbai | Nagpur | Nashik
            | Surat
          </p>
        </div>
      </Container>

      <InquiryFormModal
        show={modalshow}
        onHide={() => setmodalshow(false)}
        setmodalshow={setmodalshow}
        modalshow={modalshow}
      />
    </section>
  );
};

export default Footer;
